<template>
  <section class="">
<!-- @play="onPlayerPlay($event)"
         @pause="onPlayerPause($event)" @ended="onPlayerEnded($event)"
         @loadeddata="onPlayerLoadeddata($event)" @waiting="onPlayerWaiting($event)"
         @playing="onPlayerPlaying($event)" @timeupdate="onPlayerTimeupdate($event)"
         @canplay="onPlayerCanplay($event)" @canplaythrough="onPlayerCanplaythrough($event)"
         @ready="playerReadied" @statechanged="playerStateChanged($event)"  -->
    <div class="video-player-box" :playsinline="playsinline"

         v-video-player:myVideoPlayer="playerOption">
    </div>
  </section>
</template>

<script>

  import Vue from 'vue'
  import 'video.js/dist/video-js.css';
  const VueVideoPlayer = require('vue-video-player/dist/ssr');
  Vue.use(VueVideoPlayer);
  export default {
    data() {
      return {
        playsinline: true,
        playerOptions: {//播放器配置
          muted: false,//是否静音
          language: 'en',
          width: '9.14667rem',
          height: '5.86667rem',
          playbackRates: [0.7, 1.0, 1.5, 2.0],//播放速度
        }
      };
    },
    props: {
      videoUrl: {
        type: String,
        default: () => {
        }
      },
      poster: {
        type: String,
        default: () => {
        }
      }
    },
    computed: {
      playerOption() {
        return {
          ...this.playerOptions, sources: [{
            type: "video/mp4",
            src: this.videoUrl
          }],
          poster: this.poster,
          fluid:true
        };
      }
    },
    mounted() {
      console.log('this is current player instance object', this.myVideoPlayer);
    },
    methods: {
      /*// 监听播放
      onPlayerPlay(player) {
        console.log('player play!', player)
      },
      // 监听暂停
      onPlayerPause(player) {
         console.log('player pause!', player)
      },
      // 监听停止
      onPlayerEnded(player) {
         console.log('player ended!', player)
      },
      // 监听加载完成
      onPlayerLoadeddata(player) {
        console.log('player Loadeddata!', player)
      },
      // 监听视频缓存等待
      onPlayerWaiting(player) {
        console.log('player Waiting!', player)
      },
      // 监听视频暂停后播放
      onPlayerPlaying(player) {
         console.log('player Playing!', player)
      },
      // 监听视频播放时长更新
      onPlayerTimeupdate(player) {
        console.log('player Timeupdate!', player.currentTime())
      },
      onPlayerCanplay(player) {
        console.log('player Canplay!', player);
      },
      onPlayerCanplaythrough(player) {
         console.log('player Canplaythrough!', player)
      },
      // 监听状态改变
      playerStateChanged(playerCurrentState) {
         console.log('player current update state', playerCurrentState)
      },
      // 监听播放器准备就绪
      playerReadied(player) {
        console.log('example 01: the player is readied', player)
      }*/
    }
  }
</script>

<style lang="scss" scoped>
  .video-player-box {
    height:100%;
    width: 100%;
    border-radius: 6px;
    ::v-deep .vjs-fluid{
      height: 100%;
    }
    ::v-deep .vjs-big-play-button {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      // font-size: 20px;
      font-size: 0px;
      background: url('~@/assets/imgs/common/public_icon_play@2x.png') 100%;
      background-size: cover;
      width: 25px;
      height: 28px;
    }
    ::v-deep .vjs_video_3-dimensions.vjs-fluid{
      padding-top: 0;
    }
    ::v-deep video{

      object-fit:fill;    //消除留白
    }
    ::v-deep .vjs-fluid{
      padding-top: 0;
    }
  }
</style>

